import { useEffect, useState } from 'react';

/**
 * Creates an object URL for the given blob and automatically revokes it when the
 * blob changes or the component unmounts, preventing memory leaks.
 * Returns undefined while no blob is set.
 */
export function useObjectUrl(blob?: Blob): string | undefined {
  const [objectUrl, setObjectUrl] = useState<string>();

  useEffect(() => {
    if (!blob) {
      return undefined;
    }

    const url = URL.createObjectURL(blob);
    setObjectUrl(url);

    return () => {
      setObjectUrl(undefined);
      URL.revokeObjectURL(url);
    };
  }, [blob]);

  return objectUrl;
}
